import { Audience } from '../schema'
import { t } from 'translations'

// Names are getters so they are translated when read (this list is imported outside crm as a constant).
export const audiencesList = [
    {
        get name() {
            return t('crm.audiences.predefined.visitsToday')
        },
        slug: 'visits_today',
    },
    {
        get name() {
            return t('crm.audiences.predefined.visitsTomorrow')
        },
        slug: 'visits_tomorrow',
    },
    {
        get name() {
            return t('crm.audiences.predefined.hasEmail')
        },
        slug: 'has_email',
    },
    {
        get name() {
            return t('crm.audiences.predefined.mobileDevice')
        },
        slug: 'mobile_device',
    },
    {
        get name() {
            return t('crm.audiences.predefined.madePurchases')
        },
        slug: 'made_purchases',
    },
    {
        get name() {
            return t('crm.audiences.predefined.purchasesInLast4Weeks')
        },
        slug: 'purchases_in_last_4_weeks',
    },
    {
        get name() {
            return t('crm.audiences.predefined.twoVisitsInLast12Months')
        },
        slug: 'two_visits_in_last_12_months',
    },
    {
        get name() {
            return t('crm.audiences.predefined.hasTapApp')
        },
        slug: 'has_tap_app',
    },
    {
        get name() {
            return t('crm.audiences.predefined.madePurchasesNoTapAppInstalled')
        },
        slug: 'made_purchases_no_tap_app_installed',
    },
    {
        get name() {
            return t('crm.audiences.predefined.warmProspects')
        },
        slug: 'warm_prospects',
    },
    {
        get name() {
            return t('crm.audiences.predefined.hotProspects')
        },
        slug: 'hot_prospects',
    },
] as Audience[]
